<template>
    <div 
        class="wheel-page-wrapper" 
        :class="{ focus: selectionStarted }"
    >
        <div 
            ref="spinningWheel" 
            class="spinning-wheel-wrapper" 
            :class="{ disabled: selectionStarted, 'zoom-in': zoomIn }"
        >
            <div 
                class="resistance-ticker" 
                :style="`--rotate: ${standingOnDot ? -70 : 0}deg; --transition-duration: ${transitionDuration}ms`" 
                :class="{ 'tick-active': standingOnDot, ticking }"
            ></div>
            <div class="spinning-wheel-container" :style="`--wheel-rotation: ${wheelRotation}deg`">
                <div class="lines-wrapper">
                    <div 
                        v-for="index in availableContestants.length" 
                        :key="index" 
                        class="seperation-line"
                        :style="`--index: ${index-1}; --total: ${availableContestants.length}`"
                    ></div>
                </div>
                <div class="dots-wrapper">
                    <div
                        v-for="dot in resistanceDots"
                        :key="dot"
                        class="resistance-dot"
                        :style="`--index: ${dot-1}; --total: ${resistanceDots}`"
                    >
                        <div class="dot"></div>
                    </div>
                </div>
                <div 
                    class="spinning-wheel"
                    :style="`--background: ${backgroundStyle};`"
                ></div>
                <svg class="svg-circle" width="300" height="300" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path 
                        id="curve"
                        d="
                            M 150, 150
                            m -140, 0
                            a 140,140 0 1,1 280,0
                            a 140,140 0 1,1 -280,0
                        " 
                        fill="transparent"
                    />
                    <text v-for="(contestant, index) in availableContestants" :key="contestant.id" fill="white" :x="`${index / availableContestants.length * 879.646 + (879.646 / availableContestants.length / 2)}`">
                        <textPath v-parse-emojis class="text-path" href="#curve" text-anchor="middle" :class="{ selected: chosenUserId === contestant.id }">
                        {{ contestant.name }}
                        </textPath>
                    </text>
                </svg>

            </div>
        </div>
        <audio id="audio-player-1"></audio>
        <audio id="audio-player-2"></audio>
        <audio id="audio-player-3"></audio>
        <audio id="audio-player-4"></audio>
    </div>
</template>

<script>
import JSConfetti from 'js-confetti'

export default {
    name: 'wheel-of-fortune',
    props: {
        users: {
            type: Array,
            default() { return [] }
        }
    },
    data() {
        return {
            chosenUserId: null,
            muted: false,
            audioVolume: 0.8,
            wheelRotation: 0,
            backgroundDegrees: 0,
            demoUsers: [
                {
                    name: 'Rico',
                    id: 'da5c66e1-693e-4c9b-88b3-02fbf85bca67',
                    color: '#5b2a02'
                },
                {
                    name: 'Thomas M',
                    id: 'dcaa822d-1630-4988-bdac-2ab3b994acd1',
                    color: '#820202'
                },
                {
                    name: 'Thomas van D',
                    id: '2b02db4a-3b1c-44af-b185-0660ad04c5f4',
                    color: '#052b65'
                },
                {
                    name: 'Stephen',
                    id: '2b02db4a-3b0c-44af-b185-0660ad04c5f4',
                    color: '#820202'
                },
                {
                    name: 'Augie Larp',
                    id: '2b02db4a-3b1c-44af-b185-0660adr4c5f4',
                    color: '#052b65'
                },
                // {
                //     name: 'Augie Larrrrrrrrrp',
                //     id: '2b02db4a-3b1c-44af-b185-0460adr4c5f4',
                //     color: '#052b65'
                // },
                // {
                //     name: 'Augie Larrrrp',
                //     id: '2b02db4a-3b1c-44af-g185-0460adr4c5f4',
                //     color: '#052b65'
                // },
                // {
                //     name: 'Augie Larrrrp',
                //     id: '2b02dac4a-3b1c-44af-g185-0460adr4c5f4',
                //     color: '#052b65'
                // },
                // {
                //     name: 'Augie',
                //     id: '2b02asac4a-3b1c-44af-g185-0460adr4c5f4',
                //     color: '#052b65'
                // },
            ],
            dragging: false,
            startingPosition: null,
            wheelRotation: 0,
            startingRotation: null,
            startingWheelRotation: 0,
            lastWheelRotation: 0,
            rotate: 0,
            touchEvent: null,
            speed: 0,
            centerX: window.innerWidth / 2,
            centerY: window.innerHeight / 2,
            standingOnDot: false,
            transitionDuration: 0,
            lastAudioPlayer: 1,
            selectionStarted: false,
            zoomIn: false,
            ticking: false
        }
    },
    methods: {
        getInitials(name) {
            if(!name.includes(' ')) return name.substring(0, 2)
            const first = name.split(' ')[0];
            const last = name.split(' ').pop();
            return first.substring(0, 1) + last.substring(0, 1);
        },
        handleTargetElement(event) {
            const target = event.target;
            if(!this.$refs.spinningWheel.contains(target)) return

            this.startingPosition = {
                x: event.clientX,
                y: event.clientY
            }
            this.startingWheelRotation = this.wheelRotation;
            this.chosenUserId = null;

            this.dragging = true;
        },
        rotateWheel() {
            const deltaCenterX = this.touchEvent.clientX - this.centerX;
            const deltaCenterY = this.touchEvent.clientY - this.centerY;

            const rotation = Math.PI - Math.atan2(deltaCenterX,deltaCenterY);
            const degrees = rotation / (Math.PI * 2) * 360;
            if(this.startingRotation === null) return this.startingRotation = degrees;

            const relativeDegrees = degrees - this.startingRotation + this.startingWheelRotation;
            this.lastWheelRotation = this.wheelRotation;
            this.wheelRotation = relativeDegrees;
            return
        },
        handleTargetElementMoved(event) {
            if(!this.dragging || this.selectionStarted) return

            this.touchEvent = event.touches[0];
            window.requestAnimationFrame(this.rotateWheel);
        },
        handleClickElement() {
            if(!this.dragging || this.selectionStarted) return

            this.dragging = false;
            this.startingPosition = null;
            this.startingRotation = null;


            const speed = this.wheelRotation - this.lastWheelRotation;
            this.speed = Math.min(speed, 50);
            if(speed < 4) {
                window.requestAnimationFrame(this.handleWheelMomentum);
                this.lastWheelRotation = this.wheelRotation;
            } else {
                window.requestAnimationFrame(this.handleWheelMomentum);
                this.lastWheelRotation = this.wheelRotation;
                this.selectionStarted = true;
                this.startTicking();
                console.log('start')
            }

        },
        handleSelectionEnded() {
            if(!this.selectionStarted) return
            this.speed = 0;
            this.lastWheelRotation = this.wheelRotation;
            this.selectionStarted = false;
            this.zoomIn = false;

            const x = this.wheelRotation % 360;
            const y = this.availableContestants.length-1 - Math.floor(x / this.backgroundDegrees);

            this.chosenUserId = this.availableContestants[y].id;

            const jsConfetti = new JSConfetti();
            jsConfetti.addConfetti({
                confettiRadius: 6,
                confettiNumber: 300,
            })
            .then(() => {
                const canvas = document.querySelector('canvas');
                canvas.remove();
            });
        },
        async handleWheelMomentum() {
            if(this.dragging || (this.speed < 0.02 && !this.standingOnDot)) return this.handleSelectionEnded();

            const dotSpacing = 360 / this.resistanceDots;
            let x = this.wheelRotation % dotSpacing;
            let gain = this.speed * 0.996;
            if(x < 0) x = x * -1;
            if(x < 5 || x > (dotSpacing - 2.5)) {
                if(!this.standingOnDot && this.speed < 2) this.playTickSound();
                this.standingOnDot = true;
                gain = this.speed * 0.99;
                if(this.speed < 0.01)  gain = -0.1;
            } else this.standingOnDot = false;

            this.transitionDuration = 600 - (Math.max(gain, .6) * 800);

            this.speed = gain;
            this.wheelRotation += this.speed;
            if(this.selectionStarted && this.speed < 4) this.zoomIn = true;
            window.requestAnimationFrame(this.handleWheelMomentum);
            return
        },
        async startTicking() {
            this.ticking = true;
            while(this.speed > 2) {
                this.playTickSound();
                await new Promise(r => setTimeout(r, 100));
            }
            this.ticking = false;
        },
        playTickSound() {
            this.lastAudioPlayer++
            if(this.lastAudioPlayer > 4) this.lastAudioPlayer = 1;
            const audioPlayer = document.getElementById(`audio-player-${this.lastAudioPlayer}`);
            audioPlayer.src = `sounds/Tick-1.mp3`;
            audioPlayer.muted = false;
            audioPlayer.volume = this.audioVolume;
            audioPlayer.play();
        }
    },
    computed: {
        backgroundStyle: function() {
            let gradients = '';

            if(this.availableContestants.length == 0) return '#2e2d2d'

            this.availableContestants.forEach((contestant, index) => {
                let personalColor = '#2e2d2d';
                const seperation = index < this.availableContestants.length-1 ? ', ' : '';

                const startDegrees = this.backgroundDegrees * index;
                const endDegrees = this.backgroundDegrees * (index+1);

                const gradient = `${personalColor} ${startDegrees}deg ${endDegrees}deg${seperation}`
                gradients += gradient;
            })

            return `conic-gradient(${gradients});`
        },
        availableContestants: function() {
            if(this.users.length === 0) return this.demoUsers
            return this.users
        },
        resistanceDots: function() {
            const min = 20;
            const dotsPerUser = Math.floor(min / this.availableContestants.length);
            return dotsPerUser * this.availableContestants.length
        }
    },
    watch: {
        users: function() {
            this.backgroundDegrees = 360 / this.availableContestants.length;
        }
    },
    async created() {
        this.backgroundDegrees = 360 / this.availableContestants.length;

        // await new Promise(r => setTimeout(r, 5000));
        // this.start();
    },
    mounted() {
        const vm = this;
        this.$root.$on('targetElement', vm.handleTargetElement);
        this.$root.$on('targetElementMoved', vm.handleTargetElementMoved);
        this.$root.$on('clickElement', vm.handleClickElement);
    },
    beforeDestroy() {
        const vm = this;
        this.$root.$off('targetElement', vm.handleTargetElement);
        this.$root.$off('targetElementMoved', vm.handleTargetElementMoved);
        this.$root.$off('clickElement', vm.handleClickElement);
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';

.wheel-page-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    &:before {
        content: "";
        position: fixed;
        top: 50%;
        left: 50%;
        translate: -50% -50%;
        width: var(--absolute-width);
        height: 100dvh;
        transition: 2s cubic-bezier(.15,.75,.2,1);
    }

    &.focus {
        &:before {
            background: #00000050;
        }
        .spinning-wheel-wrapper {
            transition: scale 5000ms;
            scale: 1.2;
        }
    }

    .spinning-wheel-wrapper {
        --circle-size: calc(var(--absolute-width) * .85);

        position: fixed;
        top: 50%;
        left: 50%;
        translate: -50% -50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        z-index: 10;
        transition: scale 600ms cubic-bezier(.7,.05,.31,.95);
        transform-origin: center -10%;

        &.disabled {
            pointer-events: none;
        }

        &.zoom-in {
            scale: 1.8 !important;
            transition: scale 4000ms ease-in-out;
        }

        &::before {
            content: "";
            position: absolute;
            width: 20px;
            height: 20px;
            left: 50%;
            top: 50%;
            translate: -50% -50%;
            background: #666666;
            border: 1px solid #202220;
            border-radius: 50%;
            z-index: 12;
        }

        .resistance-ticker {
            position: absolute;
            top: -10px;
            left: 50%;
            translate: -50% 0;
            width: 8px;
            height: 20px;
            background-color: #6b0909;
            border-radius: 2px 2px 8px 8px;
            z-index: 11;

            rotate: var(--rotate);
            transform-origin: center 20%;

            transition: .3s ease-out;

            &.ticking {
                rotate: -70deg;
                animation: ticking 70ms infinite;
                transition: .1s ease;
            }

            &.tick-active {
                transition: var(--transition-duration) ease-in;
            }

            &::before {
                content: "";
                position: absolute;
                top: 2px;
                left: 50%;
                translate: -50% 0;
                width: 4px;
                height: 4px;
                background: #666666;
                border-radius: 50%;
            }
        }

        .lines-wrapper, .dots-wrapper {
            position: absolute;
            top: 50%;
            left: 50%;
            translate: -50% -50%;
            z-index: 10;
        }

        .seperation-line {
            position: absolute;
            height: calc(var(--circle-size) / 2);
            width: 2px;
            background: #202220;
            transform-origin: center bottom;
            left: 50%;
            top: 50%;
            translate: -50% -100%;
            rotate: calc(var(--index) / var(--total) * 360deg);
            z-index: 10;
        }

        .resistance-dot {
            position: absolute;
            height: calc(var(--circle-size) / 2);
            width: 6px;
            transform-origin: center bottom;
            left: 50%;
            top: 50%;
            translate: -50% -100%;
            rotate: calc(var(--index) / var(--total) * 360deg);
            z-index: 10;

            .dot {
                position: absolute;
                top: 2px;
                left: 50%;
                translate: -50% 0;
                width: 6px;
                height: 6px;
                background: #666666;
                border-radius: 50%;
            }
        }
    
        .spinning-wheel-container {
            position: relative;
            width: var(--circle-size);
            height: var(--circle-size);
            overflow: hidden;
            border-radius: 50%;
            box-shadow: 0 0 20px 7px #1a2516;
            z-index: 1;

            transform: rotate(var(--wheel-rotation));
            will-change: transform;

            .svg-circle {
                --inset: 40px;
                position: absolute;
                top: calc(var(--inset) / 2);
                left: calc(var(--inset) / 2);
                width: calc(var(--circle-size) - var(--inset));
                height: calc(var(--circle-size) - var(--inset));
                transform: rotate(90deg);

                .text-path {
                    transition: .3s ease;

                    &.selected {
                        font-size: 16px;
                        font-weight: 700;
                    }
                }
            }
            
            .spinning-wheel {
                position: relative;
                width: calc(100% - 20px);
                height: calc(100% - 20px);
                border: 10px solid #202220;
                border-radius: 50%;
                overflow: hidden;
                background: var(--background);
            }
        }
    }
}

@keyframes ticking {
    0%, 100% {
        transform: rotate(0deg);
    } 33% {
        transform: rotate(-10deg);
    } 66% {
        transform: rotate(10deg);
    }
}


</style>